/* ========== Controller ========== */
import { BookmarkModel } from './model.js';
import { BookmarkView } from './view.js';

import { fetchLinkPreview } from './linkPreviewService.js';


//Blake Gilmore 4/25 AI used to figure out lit-html
/**
 * Coordinates the model and view so neither class needs to know about the
 * other. It wires up subscriptions and event handlers at startup, then
 * delegates data operations to the model and rendering to the view.
 */
export class BookmarkController {
  /**
   * Connects the model and view by subscribing to model changes and
   * registering view event handlers, then triggers an initial render so
   * the bookmark list is displayed as soon as the app loads.
   */
  constructor(model, view) {
    this.model = model;
    this.view = view;

    this.model.subscribeBookmarkListChanged(this.onBookmarkListChanged);
    this.view.onAddBookmark(this.handleAddBookmark);
    this.view.onDeleteBookmark(this.handleDeleteBookmark);

    this.onBookmarkListChanged(this.model.bookmarks);
  }

  /**
   * Responds to model change notifications by telling the view to re-render,
   * keeping the UI in sync whenever the bookmark list is updated.
   */
  onBookmarkListChanged = (bookmarks) => {
    this.view.displayBookmarks(bookmarks);
  };


  /**
   * Forwards the user's add request to the model and returns the result
   * so the view knows whether to show a validation error or clear the form.
   */
    handleAddBookmark =  async (url, description) => {
      const previewData = await fetchLinkPreview(url);
      console.log(previewData);
    return await this.model.addBookmark(url, description,previewData);
  };

  /**
   * Forwards the user's delete request to the model using the bookmark's
   * array index so the correct entry is removed from storage and the UI.
   */
  handleDeleteBookmark = (index) => {
    this.model.deleteBookmark(index);
  };
}